module.exports = __webpack_public_path__ + "img/icon_play_real.bce030c2.png";